// extracted by mini-css-extract-plugin
export var attachment = "_oe-a";
export var emailContainer = "_oe-4";
export var emailContentPaddedContainer = "_oe-b";
export var emailHeader = "_oe-6";
export var emailIframe = "_oe-3";
export var emailInfoIcon = "_oe-9";
export var emailShortenedSummary = "_oe-e";
export var infoDropdown = "_oe-0";
export var infoRowBoundedContent = "_oe-d";
export var internal = "_oe-5";
export var merchant = "_oe-8";
export var messageInputContainer = "_oe-h";
export var normal = "_oe-7";
export var replyCard = "_oe-f";
export var subtleButton = "_oe-1";
export var subtleButtonIconContainer = "_oe-2";
export var toggleViewRepliesButton = "_oe-c";
export var wrappingText = "_oe-g";